import { useCallback } from "react";

import { ModalProps as MuiModalProps } from "@mui/material";

import { GlobalModalPropTypes } from "../GlobalModal";
import {
  ModalComponentProps,
  ModalConstantKeys,
  ModalConstants,
} from "../constants";
import { useGlobalModalContext } from "../context";

export type OnOpenModalTypeArguments<T extends ModalConstantKeys> = [
  T,
  ModalComponentProps<T>,
];

export const useOpenModal = (
  globalModalProps?: GlobalModalPropTypes & Partial<MuiModalProps>,
) => {
  const { addModal, removeOne, removeAll, updateModalProps } =
    useGlobalModalContext();

  const openModal = useCallback(
    <K extends ModalConstantKeys>(...args: OnOpenModalTypeArguments<K>) => {
      const [modalKey, modalProps] = args;
      const ModalComponent = ModalConstants[modalKey];
      const modalId = addModal(ModalComponent, modalProps, {
        ...globalModalProps,
      });

      const updateModalPropsCb = (
        newProps: Partial<ModalComponentProps<K>>,
      ) => {
        updateModalProps(modalId, newProps);
      };

      return updateModalPropsCb;
    },
    [addModal, globalModalProps, updateModalProps],
  );

  return { openModal, removeOne, removeAll };
};
